import { createContext, useContext, useState, useCallback } from "react";

const AuthModalContext = createContext(null);

export function AuthModalProvider({ children }) {
  const [mode, setMode] = useState(null); // "login" | "register" | null
  const openAuth = useCallback((m = "login") => setMode(m), []);
  const closeAuth = useCallback(() => setMode(null), []);
  return (
    <AuthModalContext.Provider value={{ mode, open: mode !== null, openAuth, closeAuth }}>
      {children}
    </AuthModalContext.Provider>
  );
}

export const useAuthModal = () => useContext(AuthModalContext);
